import { PROFILE_AI_SUMMARY_WIDGET_WARNING } from '../../ProfileAISummaryWidget'

export function isNotSummarizableError(error) {
  return (
    error?.response?.data?.error ===
    PROFILE_AI_SUMMARY_WIDGET_WARNING.notSummarizable
  )
}
